import script from "./FamilyGroupMemberListPerson.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberListPerson.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberListPerson.vue?vue&type=style&index=0&id=6cfab5b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfab5b0"]])

export default __exports__